// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.topup-credit .v-stepper {\n  box-shadow: none;\n}\n.topup-credit .v-stepper__header {\n  box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
